module.exports = __webpack_public_path__ + "static/media/right.be0857af.svg";